import React, { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import Header from './components/Header';
import SingleValidator from './components/SingleValidator';
import BulkValidator from './components/BulkValidator';
import './App.css';

export default function App() {
  const [tab, setTab] = useState('single');

  return (
    <div className="app">
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#1e2235',
            color: '#e2e8f0',
            border: '1px solid #2e3250',
            borderRadius: '10px',
            fontSize: '14px'
          },
          success: { iconTheme: { primary: '#22c55e', secondary: '#1e2235' } },
          error: { iconTheme: { primary: '#ef4444', secondary: '#1e2235' } }
        }}
      />
      <Header />
      <main className="main">
        <div className="tab-bar">
          <button
            className={`tab-btn ${tab === 'single' ? 'active' : ''}`}
            onClick={() => setTab('single')}
          >
            <span className="tab-icon">✉</span>
            Single Email
          </button>
          <button
            className={`tab-btn ${tab === 'bulk' ? 'active' : ''}`}
            onClick={() => setTab('bulk')}
          >
            <span className="tab-icon">⊞</span>
            Bulk Validation
          </button>
        </div>
        {tab === 'single' ? <SingleValidator /> : <BulkValidator />}
      </main>
    </div>
  );
}
